import { render, staticRenderFns } from "./SkillRatingDetails.vue?vue&type=template&id=615b9185&"
import script from "./SkillRatingDetails.vue?vue&type=script&lang=js&"
export * from "./SkillRatingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports